/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useCallback } from 'react';
import FilterIcon from '@atlaskit/icon/core/filter';
import { handleGinSPAClick } from '@jira/navigation-apps__common/src/utils/gin-spa/index.tsx';
import { ENTITY_ID } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { Nav4MenuLinkItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import type { JiraLinkConfig } from '@jira/platform__routing-router-components/src/ui/router-link-config/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { FILTER_HREF } from '../../constants.tsx';

type SimpleFilterMenuItemProps = {
	actionsOnHover?: React.ReactNode;
	filterId: string;
	name: string;
	onClick: () => void;
};

export function SimpleFilterMenuItem({
	actionsOnHover,
	filterId,
	name,
	onClick,
}: SimpleFilterMenuItemProps): React.JSX.Element {
	const handlOnClick = useCallback(
		(
			e:
				| React.MouseEvent<HTMLAnchorElement, MouseEvent>
				| React.KeyboardEvent<HTMLAnchorElement>
				| React.MouseEvent<EventTarget, MouseEvent>
				| React.KeyboardEvent<EventTarget>,
		) => {
			onClick?.();
			handleGinSPAClick(e);
		},
		[onClick],
	);

	return (
		<Nav4MenuLinkItem<JiraLinkConfig>
			actionsOnHover={actionsOnHover}
			elemBefore={<FilterIcon label="" color="currentColor" />}
			href={FILTER_HREF(filterId)}
			menuId={ENTITY_ID.FILTER(filterId)}
			onClick={fg('nin_remove_global_scope_enrolment') ? onClick : handlOnClick}
		>
			{name}
		</Nav4MenuLinkItem>
	);
}
